import React, {useContext,useEffect,useState} from 'react'
import {Typography} from '@mui/material'
import Box from '@mui/material/Box';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import DOMPurify from 'dompurify';
import { formularioContext } from '../contextos/FormularioContext'
import { ArrowDownIcon } from '@heroicons/react/16/solid';

export const PreguntasFrecuentes = ({id})=>{
    const {buscarPreguntasFrecuentes} = useContext(formularioContext)
    const [preguntas,setPreguntas]= useState(null)

  useEffect(()=>{
    if(id){
      buscarPreguntasFrecuentes(id)
      .then(preguntasweb=>{
          setPreguntas(preguntasweb)
      })
    }
  },[id])

if (!preguntas) return null

return  <Box sx={{p:2,width:'100%'}}> 
    <Typography style={{padding:'5px'}} variant='h5' align='left'>
     Preguntas frecuentes
 </Typography>
   {preguntas.map((item,index)=>{
       return  <SeccionPregunta
       pregunta={item.pregunta}
       respuesta={item.respuesta}
       id= {`pregunta-${index}`}
   />
   })}
</Box>
}

const SeccionPregunta = ({pregunta, respuesta,id})=>{

    return  <Accordion>
    <AccordionSummary sx={{padding:'5px'}}
      expandIcon={<ArrowDownIcon />}
      aria-controls={id}
      id={id}
    >
          <div style={{textAlign:'left',color:'#3c516b',fontWeight:'500'}} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(pregunta) }} />
    </AccordionSummary>
    <AccordionDetails>
      <div style={{fontWeight:'300'}} className='text-left' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(respuesta) }} />
    </AccordionDetails>
  </Accordion>
}